import React from 'react';
import WWLogo from '../assets/logos/WW_CircleW_Logo.svg';

/**
 * WindowWorldLogo - Reusable Window World logo component
 * 
 * A modular component for displaying the Window World logo with consistent
 * styling and proper sizing. Follows the established modular architecture.
 * 
 * @param {number} size - The size of the logo in pixels (default: 20)
 * @param {string} className - Additional CSS classes for styling
 * @param {string} alt - Alt text for accessibility (default: "Window World Logo")
 */
const WindowWorldLogo = ({
    size = 20,
    className = "",
    alt = "Window World Logo"
}) => {
    return (
        <img
            src={WWLogo}
            alt={alt}
            width={size}
            height={size}
            className={`flex-shrink-0 ${className}`}
            style={{
                maxWidth: size,
                maxHeight: size,
                objectFit: 'contain'
            }}
        />
    );
};

export default WindowWorldLogo;
